import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const AssetTypeForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'asset_type'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'asset_type.general.name_label',
            type: 'text',
            placeholder: 'asset_type.general.name_placeholder',
        },
        {
            name: 'icon',
            label: 'asset_type.general.icon_label',
            type: 'tabs',
            showIconOnly: true,
            options: [
                { name: 'asset_type.general.icon.house', value: 'house', icon: 'house' },
                { name: 'asset_type.general.icon.building', value: 'building', icon: 'building' },
                { name: 'asset_type.general.icon.layer_group', value: 'layer-group', icon: 'layer-group' },
                { name: 'asset_type.general.icon.gear', value: 'gear', icon: 'gear' },
                { name: 'asset_type.general.icon.screwdriver_wrench', value: 'screwdriver-wrench', icon: 'screwdriver-wrench' },
                { name: 'asset_type.general.icon.bolt', value: 'bolt', icon: 'bolt' },
                { name: 'asset_type.general.icon.fire', value: 'fire', icon: 'fire' },
                { name: 'asset_type.general.icon.wind', value: 'wind', icon: 'wind' },
                { name: 'asset_type.general.icon.snowflake', value: 'snowflake', icon: 'snowflake' },
                { name: 'asset_type.general.icon.sun', value: 'sun', icon: 'sun' },
                { name: 'asset_type.general.icon.umbrella_beach', value: 'umbrella-beach', icon: 'umbrella-beach' },
                { name: 'asset_type.general.icon.droplet', value: 'droplet', icon: 'droplet' },
                { name: 'asset_type.general.icon.faucet', value: 'faucet', icon: 'faucet' },
                { name: 'asset_type.general.icon.solar_panel', value: 'solar-panel', icon: 'solar-panel' },
                { name: 'asset_type.general.icon.charging_station', value: 'charging-station', icon: 'charging-station' },
                { name: 'asset_type.general.icon.video', value: 'video', icon: 'video' },
                { name: 'asset_type.general.icon.door_open', value: 'door-open', icon: 'door-open' },
                { name: 'asset_type.general.icon.warehouse', value: 'warehouse', icon: 'warehouse' },
                { name: 'asset_type.general.icon.truck', value: 'truck', icon: 'truck' },
                { name: 'asset_type.general.icon.microchip', value: 'microchip', icon: 'microchip' },
                { name: 'asset_type.general.icon.server', value: 'server', icon: 'server' },
                { name: 'asset_type.general.icon.network_wired', value: 'network-wired', icon: 'network-wired' },
                { name: 'asset_type.general.icon.battery_half', value: 'battery-half', icon: 'battery-half' },
            ]
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default AssetTypeForm;